import router from "./router";
import i18n from "./i18n";

export const NFTsModuleRouter = router;
export const NFTsModuleI18n = i18n;
